<template>

	<section class="section">

		<svg height="0" width="0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 87.04 148.97">
			<defs></defs>
			<clipPath id="rose" clipPathUnits="objectBoundingBox" transform="scale(0.01148897,0.00671276)">
			<path class="cls-1" d="M34,.5C24.44.5,21.16,5.78,14.59,11.7.79,28.78.5,58.35.5,74.5S11.3,93.83,15.57,105s-2,22.67,1.32,32.52,7.23,12.81,14.78,9.86S47.11,117.5,54,106.64s29.24-20,31.87-40.08-3-42.46-10.51-52.23S43.5.5,34,.5Z"/>
			</clipPath>
		</svg>

		<svg  height="0" width="0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 557.28 541"><defs></defs>
			<clipPath id="transp" clipPathUnits="objectBoundingBox" transform="scale(0.00179443008,0.00184842883)">
			<path d="M556.4,277.56c8.43,196.17-125.2,262.91-278.22,262.91C178.56,542.64-20.31,437.33,2.27,277.56S107.09.5,279.33.5,548,81.39,556.4,277.56Z" transform="translate(0)"/>
			</clipPath>
		</svg>

		<svg height="0" width="0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 160.53 129">
			<defs>
			</defs>
			<clipPath id="bleu" clipPathUnits="objectBoundingBox" transform="scale(0.00622936522,0.00775193798)">
			<path class="cls-1" d="M102.36,16.79c-15,0-8,15-27,20.5s-65-13.5-73,23.5,22,37.48,35,48c12,9.72,17,36,65,36s46-12,56-31-17-69-24-83S117.36,16.79,102.36,16.79Z" transform="translate(-0.53 -16.29)"/>
			</clipPath>
		</svg>

		<div class="container">    

			<div class="row justify-content-between align-items-center">
				<div class="col-sm-6 content">
					<p class="citation">
L'oiseau perché dans l'arbre ne craint pas que la branche casse parce que sa confiance n'est pas dans la branche mais dans ses ailes.

					</p>

					<div class="row justify-content-around" style="height: 50px;">
					
					</div>
					<div class="gauche">
						<transition name="FadeSlide1" appear ><img  src="../assets/img/nasa-08-rose.svg"></transition>
					</div>
					<div class="accompagnements" style="">
						<h3>J’adapte mes accompagnements à vos besoins et vos objectifs ...</h3>

						<p>Pour <span style="font-weight:bold;">Apprendre</span> à gérer les émotions, le stress, la confiance en soi, les troubles du sommeil, la fatigue ...</p>

						<p>Pour <span style="font-weight:bold;">Améliorer</span> la concentration, la mémoire, la motivation, la créativité ...</p>

						<p>Pour se <span style="font-weight:bold;">Préparer</span> de manière positive aux examens, à la maternité, aux compétitions sportives, à un changement de vie ...</p>

						<p>Pour <span style="font-weight:bold;">Agir</span> sur les douleurs, les peurs, les phobies ...</p>

						<p>N'hésitez pas à prendre rendez-vous pour un <span style="font-weight:bold;">Accompagnement Personnalisé</span>.</p>

					</div>

				</div>

				<div class="col-sm-6">
					<div  style="position:inherit;z-index:5;">
						<img class="img-fluid" style="-webkit-clip-path:url(#transp);clip-path:url(#transp);max-width:80%;" src="../assets/img/pic06.jpg">
					</div>
					<div>
						<transition name="FadeSlide2" appear ><img class="centre" style="" src="../assets/img/nasa-01-blanc.svg"></transition>
					</div>
					<div>
						<transition name="FadeSlide3" appear ><img class="droite" style="" src="../assets/img/nasa-08-orange.svg"></transition>
					</div>
				</div>

			</div>
		</div>    

	</section>
</template>

<script>

export default {
    name: 'accompagnements',
    
    metaInfo: function(){
	return{
    title: "Emmanuelle Vignon",
    titleTemplate: '%s | Mes Accompagnements en Sophrologie',
        meta: [
      { hid: "description", name: "description", content: " J’adapte mes accompagnements en sophrologie à vos besoins et vos objectifs " },
      { hid: "keywords", name: "keywords", content: " sophrologie, relaxation, blois, huisseau sur cosson, loir et cher, 41, méthode thérapeutique, sommeil, potentiel, méditation, bienêtre, sophrologue, détente, détente musculaire, corps, blocages, fatigue, harmonie, sérénité, lacher prise, stress, vitalité, accompagnement thérapeutique, maternité, paternité, confinace en soi, préparation aux examens, émotions, préparation mentale, harmonie, charge mentale, angoisses, blocages, douleurs chroniques, phobies, cohérence cardique " }      //you can also add open graph tags here
    ]
  }},
    components: { }
  }
</script>


<style scoped>
.accompagnements{
	z-index: 4;
	position: relative;
}
.accompagnements p{
	font-size: 16px;
	padding-top:10px;
}
.accompagnements h3{
	font-weight: 500;
}
.centre{
	height: 75%;
background: none;
position: absolute;
width: 75%;
z-index: 1;
bottom: -10%;
left: 5%;
}
.gauche{
	height: 60%;
position: absolute;
width: 50%;
z-index: 1;
bottom: -10%;
left: -35%;
clip-path:url(#rose);
-webkit-clip-path:url(#rose);
}
.droite{
	height: 75%;
position: absolute;
z-index: 1;
bottom: -5%;
right: 5%;
}

/*$$$$$$$$$ ANIMATIONS IMAGES $$$$$$$$*/

.FadeSlide1-enter-active, .FadeSlide1-leave-active {
  transition: all 10s cubic-bezier(.06, .97, .49, 1);
}
.FadeSlide1-enter, .FadeSlide1-leave-to  {
  opacity: 0;
  transform: translate(-50px,0);
}
.FadeSlide2-enter-active, .FadeSlide2-leave-active {
  transition: all 6s cubic-bezier(.06, .97, .49, 1);
}
.FadeSlide2-enter, .FadeSlide2-leave-to {
  opacity: 0;
  transform: translate(25px,-25px);
}
.FadeSlide3-enter-active, .FadeSlide3-leave-active {
  transition: all 6s cubic-bezier(.06, .97, .49, 1);
}
.FadeSlide3-enter, .FadeSlide3-leave-to {
  opacity: 0;
  transform: translate(-25px,-25px);
}

</style>
